import { jsx as _jsx } from "react/jsx-runtime";
import { Pressable, Text } from "@kolmeo/ui-core";
const HyperlinkMenuOption = ({ option, primaryColor }) => {
    return (_jsx(Pressable, { "data-usage-id": option.dataUsageId, onPress: option.onPress, children: _jsx(Text, { textAlign: "center", style: { textDecorationLine: "underline", fontSize: 9 }, color: primaryColor, children: option.title }) }));
};
export default HyperlinkMenuOption;
